import { HTMLInputTypeAttribute } from 'react';
import {
  OutlinedInput,
  SxProps,
  Theme,
  Typography,
  useTheme,
} from '@mui/material';
import InputWrapper from '../InputWrapper';
import { important, sxToObject } from '../../../../utils/global/helper';
import { getInputBorderStyle } from '../../../../helpers/styles';

interface Props {
  id: string;
  label?: string;
  placeholder?: string;
  disabled?: boolean;
  type?: HTMLInputTypeAttribute;
  tooltip?: string;
  suffix?: string;
  min?: number;
  max?: number;
  step?: number;
  value: string;
  onChange: (value: string) => void;
  onBlur?: () => void;
  inputSx?: SxProps<Theme>;
  isError?: boolean;
  isLabelMultiline?: boolean;
  required?: boolean;
}

function TextInputControlled({
  id,
  label,
  placeholder,
  disabled,
  type,
  value,
  onChange,
  onBlur,
  tooltip,
  suffix,
  min,
  max,
  step,
  inputSx,
  isError,
  isLabelMultiline,
  required,
}: Props) {
  const theme = useTheme();
  return (
    <InputWrapper
      label={label || ''}
      name={id.toString()}
      tooltip={tooltip}
      isLabelMultiline={isLabelMultiline}
      required={required}>
      <OutlinedInput
        id={id.toString()}
        type={type}
        name={id.toString()}
        placeholder={placeholder}
        disabled={disabled}
        onBlur={onBlur || undefined}
        sx={{
          width: '100%',
          height: important('44px'),
          fontSize: '0.875rem',
          bgcolor: theme.palette.background.default,
          '& .MuiOutlinedInput-notchedOutline': getInputBorderStyle({
            isError,
            theme,
          }),
          ...sxToObject(inputSx, theme),
        }}
        endAdornment={<Typography variant="body2">{suffix}</Typography>}
        inputProps={{ min, max, step }}
        value={value}
        onChange={e => onChange(e.target.value)}
      />
    </InputWrapper>
  );
}

export default TextInputControlled;
